module.exports = __webpack_public_path__ + "img/portrait-089.02cd5103.jpg";